var _path, _rect, _rect2, _rect3, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeEnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4304 3.83363C14.5865 4.03117 14.5345 4.31626 14.3279 4.4601C14.1212 4.60394 13.8383 4.55189 13.6806 4.35566C12.9115 3.3988 11.8891 2.67232 10.7258 2.26183C9.41885 1.80064 8.00003 1.7616 6.66968 2.15022C5.33932 2.53885 4.16463 3.3355 3.31144 4.42772C2.45825 5.51994 1.96966 6.85254 1.91464 8.23741C1.85963 9.62227 2.24097 10.9894 3.00484 12.1459C3.7687 13.3023 4.8765 14.1897 6.17183 14.6826C7.46717 15.1755 8.88461 15.2492 10.2241 14.8931C11.4163 14.5762 12.4931 13.9331 13.3356 13.0402C13.5084 12.8571 13.7946 12.8277 13.9891 12.9875C14.1837 13.1473 14.2129 13.4356 14.0416 13.6201C13.0767 14.6598 11.8351 15.4082 10.4583 15.7742C8.93423 16.1793 7.32144 16.0955 5.84758 15.5347C4.37372 14.9738 3.11325 13.9642 2.24411 12.6484C1.37497 11.3325 0.94107 9.77695 1.00367 8.20122C1.06626 6.6255 1.62219 5.10923 2.59297 3.86648C3.56374 2.62373 4.90033 1.71728 6.41403 1.2751C7.92774 0.832916 9.5421 0.877335 11.0292 1.40209C12.3727 1.87616 13.551 2.72063 14.4304 3.83363Z",
    fill: "#818181"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.75952,
    y: 3.43457,
    width: 0.907353,
    height: 5.63193,
    rx: 0.453676,
    fill: "#818181"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.57153,
    y: 8.61621,
    width: 0.907353,
    height: 5.51903,
    rx: 0.453677,
    transform: "rotate(-45 7.57153 8.61621)",
    fill: "#818181"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8455,
    y: 8.05225,
    width: 6.13148,
    height: 0.905808,
    rx: 0.452904,
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0152 6.17534C14.1855 5.99212 14.4721 5.98163 14.6553 6.15192L16.8552 8.1965C17.0385 8.36678 17.049 8.65335 16.8787 8.83657C16.7084 9.01979 16.4218 9.03028 16.2386 8.86L14.0387 6.81542C13.8554 6.64514 13.845 6.35856 14.0152 6.17534Z",
    fill: "#818181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9888 10.9038C14.1591 11.087 14.4457 11.0975 14.6289 10.9272L16.8288 8.88266C17.0121 8.71237 17.0225 8.4258 16.8523 8.24258C16.682 8.05936 16.3954 8.04887 16.2122 8.21916L14.0123 10.2637C13.829 10.434 13.8185 10.7206 13.9888 10.9038Z",
    fill: "#818181"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeEnd);
export default __webpack_public_path__ + "static/media/timeEnd.6079bbc8a418365b034f5e7057233192.svg";
export { ForwardRef as ReactComponent };